import { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

export default function Vacaciones() {
  const [solicitudes, setSolicitudes] = useState([]);

  useEffect(() => {
    const fetchVacaciones = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.RRHH.VACACIONES);
        setSolicitudes(response.data);
      } catch (error) {
        console.error("Error al cargar vacaciones:", error);
      }
    };
    fetchVacaciones();
  }, []);

  const getEstatusColor = (estatus) => {
    switch (estatus) {
      case "Aprobado":
        return "success";
      case "Pendiente":
        return "warning";
      case "Rechazado":
        return "error";
      default:
        return "default";
    }
  };

  const columns = [
    {
      Header: "No. Empleado",
      accessor: "numEmpleado",
      width: "12%",
    },
    {
      Header: "empleado",
      accessor: "empleado",
      width: "25%",
    },
    {
      Header: "fecha inicio",
      accessor: "fechaInicio",
      width: "12%",
    },
    {
      Header: "fecha fin",
      accessor: "fechaFin",
      width: "12%",
    },
    {
      Header: "días",
      accessor: "dias",
      width: "8%",
    },
    {
      Header: "días disponibles",
      accessor: "diasDisponibles",
      width: "12%",
    },
    {
      Header: "estatus",
      accessor: "estatus",
      width: "12%",
    },
    {
      Header: "acciones",
      accessor: "acciones",
      width: "10%",
    },
  ];

  const rows = solicitudes.map((item) => ({
    numEmpleado: (
      <MDTypography variant="caption" fontWeight="medium">
        {item.numEmpleado}
      </MDTypography>
    ),
    empleado: <MDTypography variant="caption">{item.empleado}</MDTypography>,
    fechaInicio: <MDTypography variant="caption">{item.fechaInicio}</MDTypography>,
    fechaFin: <MDTypography variant="caption">{item.fechaFin}</MDTypography>,
    dias: (
      <MDTypography variant="caption" fontWeight="bold" color="info">
        {item.dias}
      </MDTypography>
    ),
    diasDisponibles: (
      <MDTypography variant="caption" color="success">
        {item.diasDisponibles}
      </MDTypography>
    ),
    estatus: <Chip label={item.estatus} color={getEstatusColor(item.estatus)} size="small" />,
    acciones: (
      <MDBox display="flex" gap={1}>
        {item.estatus === "Pendiente" && (
          <>
            <MDButton variant="text" color="success" size="small" iconOnly>
              <Icon>check</Icon>
            </MDButton>
            <MDButton variant="text" color="error" size="small" iconOnly>
              <Icon>close</Icon>
            </MDButton>
          </>
        )}
        <MDButton variant="text" color="info" size="small" iconOnly>
          <Icon>visibility</Icon>
        </MDButton>
      </MDBox>
    ),
  }));

  return (
    <MDBox>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={4}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "success.main" }}>beach_access</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Solicitudes Aprobadas
              </MDTypography>
              <MDTypography variant="h3" color="success" fontWeight="bold">
                2
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "warning.main" }}>pending</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Solicitudes Pendientes
              </MDTypography>
              <MDTypography variant="h3" color="warning" fontWeight="bold">
                1
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "info.main" }}>event</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Días Promedio Disponibles
              </MDTypography>
              <MDTypography variant="h3" color="info" fontWeight="bold">
                13.25
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
      </Grid>

      <Card>
        <MDBox p={3}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <MDTypography variant="h6" fontWeight="medium">
              Gestión de Vacaciones
            </MDTypography>
            <MDButton variant="gradient" color="success">
              <Icon>add</Icon>&nbsp;Nueva Solicitud
            </MDButton>
          </MDBox>

          <DataTable
            table={{ columns, rows }}
            showTotalEntries={true}
            isSorted={true}
            noEndBorder
            entriesPerPage={true}
          />
        </MDBox>
      </Card>
    </MDBox>
  );
}
